<template>
  <div>
    <Modal v-model="splitOrderModal" :title="$t('key1006371')" width="1200" class-name="commonModalStyles"
      :styles="{top: '50px'}" :transfer="false" @on-visible-change="splitOrderChange">
      <!--订单商品信息-->
      <Card :bordered="false" dis-hover class="mb20">
        <template #title>
          <h2 class="title_box">{{ $t('key1006142') }}</h2>
        </template>
        <div class="orderLogistics_box" v-for="(ele,idx) in orderProductInfoList">
          <!--商品-->
          <Col :span="8" style="display: flex" class="pr20">
            <div class="orderLogistics_img_box">
              <img :src="ele.pictureUrl" alt="">
            </div>
            <div class="ml12" style="flex: 1;">
              <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.name">{{ ele.name }}</h2>
              <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
              <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
              <div class="flex align-items-center" v-if="ele.isNeedCustomization === 1">
                <span>{{ $t('key1006348') + ele.originalYmsSku + '）' }}</span>
                <Tooltip transfer placement="top" max-width="500" :content="$t('key1004306')">
                  <Icon size="20" color="#FD5425" class="cursor" type="md-alert"></Icon>
                </Tooltip>
              </div>
              <p class="distributorThemeColor">{{ ele.specifications }}</p>
            </div>
          </Col>
          <Col :span="7">
            <p class="flex align-items-center mb6">
              <span>{{ $t('key1006372') }}</span>
              <Select v-model.trim="ele.platformOrderTransactionId" transfer style="width:180px;">
                <Option v-for="(k, index) in ymsPlatformOrderTransactionsList" :key="index" :value="k.platformOrderTransactionId">
                  {{ k.name }}
                </Option>
              </Select>
            </p>
          </Col>
          <!--重量-->
          <Col :span="3" style="text-align: center;">
            <span>{{ $t('key1006443') + (preSplitOrderStatusTalg ? ele.goodWeight : ele.productGoodsWeight) + 'g' }}</span>
          </Col>
          <!--订单数量-->
          <Col :span="3" style="text-align: center;">
            <span>{{ $t('key1004355') + ele.quantity }}</span>
          </Col>
          <!--单价-->
          <Col :span="3" style="text-align: center;">
            <span>{{ $t('key1004354') + (preSplitOrderStatusTalg ? ele.goodSuggestPrice : ele.productGoodsCost) }}</span>
            <span class="ml4">{{ preSplitOrderStatusTalg ? ele.goodCurrency : ele.currency }}</span>
          </Col>
        </div>
      </Card>
      <!--拆分后订单信息-->
      <Card :bordered="false" dis-hover class="reset_card_box">
        <template #title>
          <div class="flex justify-content-between align-items-center">
            <h2 class="title_box">{{ $t('key1006446') }}</h2>
            <span class="distributorThemeColor cursor" @click="addOrderBtn">{{ $t('key1006447') }}</span>
          </div>
        </template>
        <Collapse v-model="splitOrderInfoList" class="orderLogisticsCollapse_box">
          <Panel :name="index + '_collapse'" v-for="(item,index) in splitOrderInfoData" :key="index + '_collapse'">
            <div class="flex align-items-center justify-content-between" style="width:98%;" @click.stop>
              <div class="flex align-items-center flex-wrap" style="width:600px;">
                <span class="distributorThemeColor mr24">{{ $t('key1000124') + (index + 1) }}</span>
                <template v-if="item.carrierShippingMethodCode">
                  <span class="mr20">{{ $t('key1000122') + item.carrierShippingMethodName }}</span>
                </template>
                <template v-else>
                  <span>{{ $t('key1000122') }}</span>
                  <span class="mr20" style="color: #EA0000">{{ $t('key1006448') }}</span>
                </template>
              </div>
              <div class="flex align-items-center">
              <span class="distributorThemeColor cursor mr20" @click.stop="deliveryMethodBtn(item, index)">
                {{ item.carrierShippingMethodCode ? $t('key1000412') : $t('key1000407') }}
              </span>
                <span class="distributorThemeColor cursor" v-if="splitOrderInfoData.length >1"
                  @click.stop="deleteOrderBtn(index)">{{ $t('key1006449') }}</span>
                <div class="flex align-items-center ml20 " v-if="item.showIoss">
                  <Icon v-if="Object.keys(item.iossConfig).length > 0" class="mr4" size="20" color="#20B759" type="ios-checkmark-circle"/>
                  <Icon v-else class="mr4" size="20" color="#EA0000" type="ios-close-circle"/>
                  <span class="distributorThemeColor cursor"
                    @click.stop="iossConfigBtn(item,index)">{{ $t('key1005994') }}</span>
                </div>
              </div>
            </div>
            <template #content>
              <template v-if="item.goodList.length >0">
                <div class="orderLogistics_box" v-for="(ele,idx) in item.goodList">
                  <!--商品-->
                  <Col :span="7" style="display: flex" class="pr10">
                    <div class="orderLogistics_img_box">
                      <img :src="ele.pictureUrl" alt="">
                    </div>
                    <div class="ml12" style="flex: 1;">
                      <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.name">{{ ele.name }}</h2>
                      <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
                      <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
                      <div class="flex align-items-center" v-if="ele.isNeedCustomization === 1">
                        <span>{{ $t('key1006348') + ele.originalYmsSku + '）' }}</span>
                        <Tooltip transfer placement="top" max-width="500" :content="$t('key1004306')">
                          <Icon size="20" color="#FD5425" class="cursor" type="md-alert"></Icon>
                        </Tooltip>
                      </div>
                      <p class="distributorThemeColor">{{ ele.specifications }}</p>
                    </div>
                  </Col>
                  <!--发货仓-->
                  <Col :span="5" class="text-center">
                    <div class="shippingWarehousePrompt_content">
                      <span>{{ $t('key1001227') }}</span>
                      <Select v-model="ele.ymsWarehouseId" filterable :class="ele.ymsWarehouseIdTalg ? 'ivu-form-item-error' : ''"
                        style="width: 160px;" transfer @on-change="(value)=>selectChange(value, ele, idx, index)"
                        @on-open-change="(value) => openChange(value, ele, idx, index)"
                        :disabled="orderStatusTalg && ele.isNeedCustomization === 1 && allowInvalid === 0">
                        <Option v-for="talg in ele.shippingWarehouseList" :disabled="talg.availableNumber<=0"
                          :value="talg.ymsWarehouseId" :key="talg.ymsWarehouseId" :label="talg.name">
                          <div class="flex align-items-center justify-content-between">
                            <span :class="talg.availableNumber<=0 ? '' : 'color-333'">{{ talg.name }}</span>
                            <span class="font-size-12 color-999">{{ '（' + $t('key1003367') + talg.availableNumber + '）' }}</span>
                          </div>
                        </Option>
                      </Select>
                      <span v-if="ele.ymsWarehouseIdTalg" class="shippingWarehousePrompt_box">
                        {{ $t('key1006438') }}
                      </span>
                    </div>
                  </Col>
                  <!--合规信息-->
                  <Col :span="5" v-if="ele.isShowComplianceInfoTalg && orderComplianceLabelVerificationTalg">
                    <div class="flex flex-direction">
                      <!--责任人-->
                      <div class="flex align-items-center justify-content-end mb15" v-for="item in responsibleAreaList.filter(j => j.zoneCode === receivingAddressZoneCode)">
                        <span class="red-dot">{{ item.name + '：' }}</span>
                        <Select v-model="ele.selectYmsCompliancePersonId" filterable style="width: 160px;">
                          <Option v-for="k in personInChargeList.filter(talg => talg.zoneCode === receivingAddressZoneCode)" :value="k.ymsCompliancePersonId">
                            {{ k.name }}
                          </Option>
                        </Select>
                      </div>
                      <!--制造商-->
                      <div class="flex align-items-center justify-content-end">
                        <span class="red-dot">{{ $t('key1000282') }}</span>
                        <Select v-model="ele.selectYmsManufacturerInfoId" filterable style="width: 160px;">
                          <Option v-for="k in manufacturerData" :value="k.ymsManufacturerInfoId">{{ k.name }}</Option>
                        </Select>
                      </div>
                    </div>
                  </Col>
                  <!--库存-->
                  <Col :span="2" class="text-center">
                    <div>{{ $t('key1003367') + ele.availableNumber }}</div>
                  </Col>
                  <!--数量-->
                  <Col :span="3" class="text-center">
                    <InputNumber class="reset_input_style" v-model="ele.quantity" controls-outside style="width: 130px;"
                      :disabled="orderStatusTalg && ele.isNeedCustomization === 1 && allowInvalid === 0"
                      :formatter="value => `${parseInt(value)}`" :max="ele.availableNumber" :min="1">
                    </InputNumber>
                  </Col>
                  <!--删除-->
                  <Col :span="2" class="text-center">
                    <div v-if="item.goodList.length >1 && !(orderStatusTalg && ele.isNeedCustomization === 1 && allowInvalid === 0)"
                      @click="deleteSkuBtn(ele, item, index)" class="cursor" style="color: #EA0000">{{ $t('key1000105') }}
                    </div>
                  </Col>
                </div>
              </template>
            </template>
          </Panel>
        </Collapse>
      </Card>
      <template #footer>
        <Button @click="splitOrderModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="splitOrderBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--配送方式弹窗-->
    <distributionModeModal ref="distributionMode" @updateDeliveryMethodData="updateDeliveryMethodData"></distributionModeModal>
    <!--IOSS配置弹窗-->
    <uploadIossModal ref="uploadIoss" :receivingAddress="receivingAddress" @updateIossData="updateIossData"></uploadIossModal>
    <!--拆分订单确认弹窗-->
    <Modal v-model="splitOrderConfirmationModal" :title="$t('key1006442')" width="800" :transfer="false" class-name="commonModalStyles">
      <h2 class="font-weight-bold mb24">{{ $t('key1006450') }}</h2>
      <div class="orderLogistics_box" v-for="ele in splitOrderConfirmationList">
        <!--商品-->
        <Col :span="12" style="display: flex" class="pr20">
          <div class="orderLogistics_img_box">
            <img :src="ele.pictureUrl" alt="">
          </div>
          <div class="ml12" style="flex: 1;">
            <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.name">{{ ele.name }}</h2>
            <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
            <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
            <div class="flex align-items-center" v-if="ele.isNeedCustomization === 1">
              <span>{{ $t('key1006348') + ele.originalYmsSku + '）' }}</span>
              <Tooltip transfer placement="top" max-width="500" :content="$t('key1004306')">
                <Icon size="20" color="#FD5425" class="cursor" type="md-alert"></Icon>
              </Tooltip>
            </div>
            <p class="distributorThemeColor">{{ ele.specifications }}</p>
          </div>
        </Col>
        <!--原数量-->
        <Col :span="5">
          <span>{{ $t('key1006444') + ele.quantity }}</span>
        </Col>
        <!--拆分后数量-->
        <Col :span="6">
          <span>{{ $t('key1006445') + ele.totalQuantity }}</span>
        </Col>
      </div>
      <template #footer>
        <Button @click="splitOrderConfirmationModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="splitOrderConfirmationBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--物流单作废费收取提示弹窗-->
    <collectionOfScrapFeesForLogisticsModal ref="collectionOfScrapFeesForLogistics" @updateSubmit="updateSubmit"></collectionOfScrapFeesForLogisticsModal>
    <!--订单提交弹窗-->
    <orderSubmissionModal ref="orderSubmission" @updateOrderData="updateOrderData"></orderSubmissionModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import uploadIossModal from "@/views/distributor/components/orderManage/components/uploadIossModal.vue";
import distributionModeModal from "@/components/common/distributionModeModal.vue";
import {
  getAllManufacturerData, getAllPersonInChargeData, getCountryZoneData,commonLocalStorage,
  getIossTaxRateData, getProductShippingWarehouseInventory, getTrialGoodsPrice, amountHandel
} from "@/utils/common";
import collectionOfScrapFeesForLogisticsModal from "@/components/common/collectionOfScrapFeesForLogisticsModal.vue";
import orderSubmissionModal from "@/components/common/orderSubmissionModal.vue";

export default {
  name: 'splitOrderModal',
  mixins: [Mixin],
  props: {
    ymsPlatformOrderTransactionsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      splitOrderModal: false,
      orderProductInfoList: [],
      platformOrderDetails: null,
      splitOrderInfoList: [],
      splitOrderInfoData: [],
      ymsPlatformOrderId: null,
      iossTaxRateList: [],
      originalNewList: [],
      splitOrderConfirmationList: [],
      splitOrderConfirmationModal: false,
      detailsObj: {},
      destinationCountryTalg: false,
      currentIndex: null,
      orderStatusTalg: false, // false 未下单   true  已下单
      allowInvalid: null, // 1 允许标记取消   0不允许标记取消
      receivingAddress: {},
      responsibleAreaList: [],
      relatedComplianceInfoData: [],
      personInChargeList: [],
      manufacturerData: [],
    }
  },
  computed: {
    // 判断是在预拆单的状态
    preSplitOrderStatusTalg() {
      return (![0, 1].includes(this.platformOrderDetails.status) && this.platformOrderDetails.status < 4) || this.platformOrderDetails.status === 11;
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 判断收货地址是否是欧盟、土耳其
    receivingAddressZoneCode() {
      let zoneCode = null;
      let {countryCode} = this.receivingAddress;
      if (countryCode) {
        this.responsibleAreaList.map((item) => {
          if (item.countries.includes(countryCode)) {
            zoneCode = item.zoneCode;
          }
        })
      }
      return zoneCode;
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },
  methods: {
    // 初始化数据
    async initSplitOrderData(obj, platformOrderDetails) {
      let copyObj = JSON.parse(JSON.stringify(obj));
      await getIossTaxRateData('distributor').then((newData) => {
        this.iossTaxRateList = newData;
      });
      await getAllPersonInChargeData().then((data) => {
        this.personInChargeList = data;
      });
      await getAllManufacturerData().then((data) => {
        this.manufacturerData = data;
      });
      await getCountryZoneData().then((data) => {
        this.responsibleAreaList = data;
      });
      this.detailsObj = copyObj;
      this.platformOrderDetails = platformOrderDetails;
      this.ymsPlatformOrderId = platformOrderDetails.ymsPlatformOrderId;
      this.orderProductInfoList = copyObj.goodsList;
      // 判断当前订单是否已经下单
      this.orderStatusTalg = ((![0, 1, 12].includes(platformOrderDetails.status) && platformOrderDetails.status < 4) ||
        [11, 21].includes(platformOrderDetails.status)) ? false : true;
      this.allowInvalid = copyObj.ymsPackageInfo.allowInvalid;
      let {
        buyerCountryCode, buyerPostalCode, buyerAddress1, buyerCity,
        buyerMobile, buyerName, buyerAccountId, buyerEmail, buyerPhone
      } = copyObj.ymsPackageInfo;
      this.receivingAddress = {
        countryCode: buyerCountryCode,
        city: buyerCity,
        mobile: buyerMobile,
        name: buyerName,
        buyerAccountId: buyerAccountId,
        email: buyerEmail,
        phone: buyerPhone,
        postalCode: buyerPostalCode,
        streetAddress: buyerAddress1,
      };
      // 是否在IOSS目的国范围中
      this.destinationCountryTalg = this.iossTaxRateList.some((item) => {
        return item.countryCode === this.receivingAddress.countryCode;
      });
      let ymsProductGoodsIds = [];
      let newGoodList = JSON.parse(JSON.stringify(copyObj.goodsList));
      newGoodList.map((item) => {
        let ymsProductGoodsId = null;
        item.ymsWarehouseId = copyObj.ymsWarehouseId;
        item.shippingWarehouseList = [];
        item.availableNumber = 0;
        item.quantity = 1;
        item.ymsWarehouseIdTalg = false;
        item.selectYmsCompliancePersonId = null;
        item.selectYmsManufacturerInfoId = null;
        if (item.isNeedCustomization === 1) {
          ymsProductGoodsId = item.originalYmsProductGoodsId;
        } else {
          ymsProductGoodsId = item.ymsProductGoodsId;
        }
        if (ymsProductGoodsId) {
          ymsProductGoodsIds.push(ymsProductGoodsId);
        }
      });
      // 处理回显发货仓
      if (ymsProductGoodsIds.length > 0) {
        getProductShippingWarehouseInventory(ymsProductGoodsIds).then((data) => {
          if (data.length > 0) {
            newGoodList.map((ele) => {
              let countryCode = null;
              let ymsProductGoodsId = ele.isNeedCustomization === 1 ? ele.originalYmsProductGoodsId : ele.ymsProductGoodsId;
              data.map((item) => {
                if (ymsProductGoodsId === item.ymsProductGoodsId) {
                  let list = item.productDeliverWarehouseResultBos || [];
                  let newList = list.sort((a, b) => b.availableNumber - a.availableNumber);
                  newList.map((talg) => {
                    if (talg.ymsWarehouseId === ele.ymsWarehouseId) {
                      ele.availableNumber = talg.availableNumber;
                      // 是否展示合规信息
                      let ymsWarehouseAddress = talg.ymsWarehouseAddress || [];
                      ymsWarehouseAddress.map((k) => {
                        if (k.addressType === 'sender') {
                          countryCode = k.countryCode;
                        }
                      })
                      if (this.receivingAddressZoneCode) {
                        this.responsibleAreaList.map((k) => {
                          if (k.zoneCode === this.receivingAddressZoneCode) {
                            if (!k.countries.includes(countryCode)) {
                              ele.isShowComplianceInfoTalg = true;
                            }
                          }
                        })
                      } else {
                        ele.isShowComplianceInfoTalg = false;
                      }
                    }
                  });
                  ele['shippingWarehouseList'] = newList;
                }
              })
            });
            this.originalNewList = JSON.parse(JSON.stringify(newGoodList));
            newGoodList.map((item) => {
              if (item.isShowComplianceInfoTalg) {
                const spuInfo = item._productInfo && item._productInfo._spuInfo;
                const compliancePersonProductList = Array.isArray(spuInfo?.compliancePersonProductList)
                  ? spuInfo.compliancePersonProductList : [];
                const ymsManufacturerInfoProductList = Array.isArray(spuInfo?.ymsManufacturerInfoProductList)
                  ? spuInfo.ymsManufacturerInfoProductList : [];
                // 负责人
                let ymsProductId = item.ymsProductId || spuInfo.ymsProductId;
                const compliance = compliancePersonProductList.find(
                  ele => ele.ymsProductId === ymsProductId && ele.zoneCode === this.receivingAddressZoneCode);
                item.selectYmsCompliancePersonId = compliance
                  ? compliance.ymsCompliancePersonId : item.selectYmsCompliancePersonId || null;

                // 制造商
                const manufacturer = ymsManufacturerInfoProductList.find(
                  ele => ele.ymsProductId === ymsProductId && ele.zoneCode === this.receivingAddressZoneCode);
                item.selectYmsManufacturerInfoId = manufacturer
                  ? manufacturer.ymsManufacturerInfoId : item.selectYmsManufacturerInfoId || null;
              }
            })
            this.splitOrderInfoData = [{
              ymsWarehouseId: copyObj.ymsWarehouseId,
              carrierShippingMethodName: '', // 物流渠道名称
              carrierShippingMethodCode: '', // 物流方案代码
              deliveryMethodDetails: {}, // 配送方式
              iossConfig: {}, // ioss配置
              showIoss: false, // 是否展示ioss配置 this.destinationCountryTalg
              goodList: newGoodList
            }];
          }
        });
      }
      this.splitOrderModal = true;
    },
    // 配送方式
    deliveryMethodBtn(item, index) {
      this.currentIndex = index;
      let type = item.carrierShippingMethodCode ? 'edit' : 'select';
      let goodList = item.goodList;
      const firstWarehouseId = goodList[0].ymsWarehouseId;
      const allSame = goodList.every(item => item.ymsWarehouseId === firstWarehouseId);
      if (allSame) {
        let obj = Object.assign({}, item);
        obj.ymsWarehouseId = firstWarehouseId;
        this.$refs['distributionMode'].initDistributionModeData(type, obj, this.receivingAddress);
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006437'));
        return false;
      }
    },
    // ioss配置
    iossConfigBtn(item, index) {
      this.currentIndex = index;
      this.$refs['uploadIoss'].initUploadIossData(item, 'ymsOrder', this.ymsPlatformOrderId)
    },
    // 更新配送方式数据
    updateDeliveryMethodData(data) {
      this.splitOrderInfoData.map((item, index) => {
        if (item.ymsWarehouseId === data.ymsWarehouseId && index === this.currentIndex) {
          item.deliveryMethodDetails = data;
          item.carrierShippingMethodName = data.name;
          item.carrierShippingMethodCode = data.code;
          let iossStatus = item.deliveryMethodDetails.iossStatus;
          let carrierMerchantType = item.deliveryMethodDetails.carrierMerchantType;
          item.showIoss = iossStatus === 1 && carrierMerchantType === 3; // 使用的是yms物流，并且需要收取清关费才能走ioss配置
        }
      });
    },
    // 更新ioss配置
    updateIossData(data) {
      this.splitOrderInfoData.map((item, index) => {
        if (item.ymsWarehouseId === data.ymsWarehouseId && index === this.currentIndex) {
          item.iossConfig = data;
        }
      });
    },
    // 增加订单
    addOrderBtn() {
      this.splitOrderInfoData.push({
        ymsWarehouseId: this.detailsObj.ymsWarehouseId,
        carrierShippingMethodName: '', // 物流渠道名称
        carrierShippingMethodCode: '', // 物流方案代码
        deliveryMethodDetails: {}, // 配送方式
        iossConfig: {}, // ioss配置
        showIoss: false, // 是否展示ioss配置 this.destinationCountryTalg
        goodList: this.originalNewList,

      });
    },
    // 删除订单
    deleteOrderBtn(index) {
      this.splitOrderInfoData.splice(index, 1);
      this.consistentDeliveryWarehouse(index);
      this.$forceUpdate();
    },
    // 删除sku
    deleteSkuBtn(ele, item, index) {
      let list = item.goodList.filter((talg) => talg.ymsSku !== ele.ymsSku);
      this.$set(this.splitOrderInfoData[index], 'goodList', list);
      this.consistentDeliveryWarehouse(index);
    },
    // 选择发货仓
    selectChange(value, obj, idx, index) {
      let countryCode = null;
      let isShowComplianceInfoTalg = false;
      let shippingWarehouseList = obj.shippingWarehouseList || [];
      let availableNumber = shippingWarehouseList.filter((ele) => ele.ymsWarehouseId === value)[0].availableNumber;
      let ymsWarehouseAddress = shippingWarehouseList.filter((ele) => ele.ymsWarehouseId === value)[0].ymsWarehouseAddress || [];
      this.splitOrderInfoData.map((item, ids) => {
        if (ids === index) {
          item.deliveryMethodDetails = {};
          item.carrierShippingMethodName = '';
          item.carrierShippingMethodCode = '';
        }
      });
      if (obj.quantity > availableNumber) {
        this.$set(this.splitOrderInfoData[index].goodList[idx], 'quantity', availableNumber);
      }
      this.$set(this.splitOrderInfoData[index].goodList[idx], 'availableNumber', availableNumber);
      ymsWarehouseAddress.map((k) => {
        if (k.addressType === 'sender') {
          countryCode = k.countryCode;
        }
      });
      if (this.receivingAddressZoneCode) {
        this.responsibleAreaList.map((ele) => {
          if (ele.zoneCode === this.receivingAddressZoneCode) {
            if (!ele.countries.includes(countryCode)) {
              isShowComplianceInfoTalg = true;
            }
          }
        })
      } else {
        isShowComplianceInfoTalg = false;
      }
      this.$set(this.splitOrderInfoData[index].goodList[idx], 'isShowComplianceInfoTalg', isShowComplianceInfoTalg);
      this.consistentDeliveryWarehouse(index);
    },
    // 判断当前订单的发货仓是否一致
    consistentDeliveryWarehouse(index) {
      let v = this;
      setTimeout(() => {
        const goodList = v.splitOrderInfoData[index].goodList || [];
        if (goodList.length > 0) {
          const firstWarehouseId = goodList[0].ymsWarehouseId;
          const allSame = goodList.every(item => item.ymsWarehouseId === firstWarehouseId);
          v.$set(this.splitOrderInfoData[index], 'ymsWarehouseId', firstWarehouseId);
          goodList.forEach(item => {
            v.$set(item, 'ymsWarehouseIdTalg', !allSame);
          });
        }
      }, 800);
      v.$forceUpdate();
    },
    // 展开选择发货仓下拉框
    openChange(value, obj, idx, index) {
      let shippingWarehouseList = obj.shippingWarehouseList || [];
      let ymsProductGoodsId = obj.isNeedCustomization === 1 ? obj.originalYmsProductGoodsId : obj.ymsProductGoodsId;
      if (value && shippingWarehouseList.length <= 0) {
        getProductShippingWarehouseInventory([ymsProductGoodsId]).then((data) => {
          if (data.length > 0) {
            data.map((item) => {
              if (item.ymsProductGoodsId === ymsProductGoodsId) {
                let list = item.productDeliverWarehouseResultBos || [];
                let newData = list.sort((a, b) => b.availableNumber - a.availableNumber);
                this.$set(this.splitOrderInfoData[index].goodList[idx], 'shippingWarehouseList', newData);
                this.$forceUpdate();
              }
            })
          }
        });
      }
    },
    // 确定按钮
    splitOrderBtn() {
      let deliveryMethodTalg = this.splitOrderInfoData.every((item) => {
        return Object.keys(item.deliveryMethodDetails).length > 0
      });
      if (!deliveryMethodTalg) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005978'));
        return false;
      }
      let iossConfigValid = this.splitOrderInfoData.every(item => {
        if (item.showIoss === true) {
          return item.iossConfig && Object.keys(item.iossConfig).length > 0;
        }
        return true;
      });
      if (!iossConfigValid) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005979'));
        return false;
      }
      for (const order of this.splitOrderInfoData) {
        for (const item of order.goodList) {
          if (item.ymsWarehouseIdTalg) {
            this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006438'));
            return false;
          }
          if (item.quantity == null || item.quantity <= 0) {
            this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006439'));
            return false;
          }
        }
      }
      // 校验合规信息必填（仅配置项开启时）
      if (this.orderComplianceLabelVerificationTalg) {
        const goods = this.splitOrderInfoData.flatMap(order => order.goodList || []).filter(good => good.isShowComplianceInfoTalg);
        const invalid = goods.filter(good => !good.selectYmsCompliancePersonId || !good.selectYmsManufacturerInfoId);
        if (invalid.length > 0) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006440'));
          return false;
        }
      }
      // 处理拆分之后的信息汇总
      const skuMap = {};
      this.splitOrderInfoData.forEach(order => {
        order.goodList.forEach(item => {
          const sku = item.ymsSku;
          const qty = Number(item.quantity) || 0;
          if (skuMap[sku]) {
            skuMap[sku] += qty;
          } else {
            skuMap[sku] = qty;
          }
        });
      });
      let skuList = Object.keys(skuMap).map(sku => ({
        ymsSku: sku,
        totalQuantity: skuMap[sku]
      }));
      if (skuList.length > 0) {
        let newOrderProductInfoList = this.orderProductInfoList.reduce((acc, item) => {
          const existing = acc.find(i => i.ymsProductGoodsId === item.ymsProductGoodsId);
          if (existing) {
            existing.quantity += item.quantity;
          } else {
            acc.push({...item});
          }
          return acc;
        }, []);
        newOrderProductInfoList.map((item) => {
          skuList.map((ele) => {
            if (item.ymsSku === ele.ymsSku) {
              item.totalQuantity = ele.totalQuantity;
            }
          })
        });
        let newList = newOrderProductInfoList.filter((item) => item.totalQuantity !== item.quantity);
        if (newList.length > 0) {
          this.splitOrderConfirmationList = newList;
          this.splitOrderConfirmationModal = true;
        } else {
          this.splitOrderConfirmationBtn();
        }
      }
    },
    updateSubmit() {
      this.saveData();
    },
    // 处理保存数据
    saveData() {
      let v = this;
      let query = {
        orderShippingId: v.detailsObj.ymsPlatformOrderShippingId,
        platformOrderCreateOrderBoList: [],
        ymsPlatformOrderId: v.ymsPlatformOrderId
      }
      let {
        buyerAccountId, buyerAddress1, buyerAddress2, buyerCity, buyerCountryCode, buyerEmail, buyerMobile,
        buyerName, buyerPassportCode, buyerPhone, buyerPostalCode, buyerState
      } = v.detailsObj;
      v.splitOrderInfoData.map((item) => {
        let {ymsWarehouseId, deliveryMethodDetails, showIoss, iossConfig, goodList} = item;
        let carrierMerchantType = deliveryMethodDetails.carrierMerchantType;
        // 处理组装定制商品的信息
        let ymsPackageGoodsList = v.processingCustomAssembledProducts(goodList);
        let iossObj = {};
        if (showIoss) {
          iossObj = {
            iossLogisticCost: iossConfig.iossLogisticCost,
            iossNo: iossConfig.iossNo,
            iossType: iossConfig.iossType,
          }
        }
        let ymsCompliancePersonProductBosList = [];
        let insertYmsManufacturerInfoProductBosList = [];
        goodList.map((ele) => {
          if (ele.isShowComplianceInfoTalg && v.orderComplianceLabelVerificationTalg) {
            // 责任人
            if (ele.selectYmsCompliancePersonId) {
              ymsCompliancePersonProductBosList.push({
                ymsCompliancePersonId: ele.selectYmsCompliancePersonId,
                ymsDistributorMerchantId: v.userInfo.merchantId,
                ymsProductId: ele.ymsProductId,
                zoneCode: v.receivingAddressZoneCode
              })
            }
            // 制造商
            if (ele.selectYmsManufacturerInfoId) {
              insertYmsManufacturerInfoProductBosList.push({
                ymsManufacturerInfoId: ele.selectYmsManufacturerInfoId,
                ymsDistributorMerchantId: v.userInfo.merchantId,
                ymsProductId: ele.ymsProductId,
                zoneCode: v.receivingAddressZoneCode
              })
            }
          }
        })
        query.platformOrderCreateOrderBoList.push({
          buyerAccountId,
          buyerAddress1,
          buyerAddress2,
          buyerCity,
          buyerCountryCode,
          buyerEmail,
          buyerMobile,
          buyerName,
          buyerPassportCode,
          buyerPhone,
          buyerPostalCode,
          buyerState,
          ...iossObj,
          carrierId: carrierMerchantType !== 3 ? deliveryMethodDetails.carrierId : null,
          shippingMethodId: carrierMerchantType !== 3 ? deliveryMethodDetails.shippingMethodId : null,
          carrierMerchantType: carrierMerchantType,
          warehouseId: ymsWarehouseId,
          ymsLogisServiceId: carrierMerchantType === 3 ? deliveryMethodDetails.ymsLogisServiceId : null,
          isNeedCustomization: goodList.some((k) => k.isNeedCustomization === 1) ? 1 : 0,
          ymsPackageGoods: ymsPackageGoodsList,
          ymsPlatformOrderId: v.ymsPlatformOrderId,
          ymsCompliancePersonProductBos: ymsCompliancePersonProductBosList,
          insertYmsManufacturerInfoProductBos: insertYmsManufacturerInfoProductBosList,
        });
      });
      v.setPrice().then((data) => {
        if (data.length > 0) {
          let totalPayable = data.reduce((pre, cur) => {
            return Number(pre) + Number(cur.totalOrderAmount);
          }, 0);
          let obj = {
            totalPrice: Number(totalPayable),
            currency: v.currencyState,
            params: {
              url: api.post_ymsPlatformOrder_splitOrder,
              query,
              text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006441')
            },
          }
          this.$refs['orderSubmission'].initOrderSubmissionData(obj)
        }
      });
    },
    // 下单成功，更新操作
    updateOrderData(obj) {
      let {text} = obj;
      this.splitOrderModal = false;
      this.splitOrderConfirmationModal = false;
      this.$Message.success(text);
      this.$emit('updateData', true);
    },
    // 获取试算价格
    setPrice() {
      return new Promise((resolve) => {
        let queryList = [];
        this.splitOrderInfoData.map((item) => {
          let {ymsWarehouseId, deliveryMethodDetails, goodList} = item;
          let priceTrialGoodsBoList = this.processingCustomAssembledProducts(goodList);
          let carrierMerchantType = deliveryMethodDetails.carrierMerchantType;
          if (priceTrialGoodsBoList.length > 0) {
            queryList.push({
              countryCode: this.receivingAddress.countryCode,
              priceTrialGoodsBoList: priceTrialGoodsBoList,
              shippingMethodId: carrierMerchantType === 3 ? null : deliveryMethodDetails.shippingMethodId,
              ymsDistributorMerchantId: this.userInfo.merchantId,
              ymsLogisServiceId: carrierMerchantType === 3 ? deliveryMethodDetails.ymsLogisServiceId : null,
              buyerPostalCode: this.receivingAddress.postalCode,
              carrierMerchantType: carrierMerchantType,
              carrierMerchantId: carrierMerchantType === 1 ? deliveryMethodDetails.merchantId : null,
              warehouseIds: [ymsWarehouseId],
            });
          }
        });
        if (queryList.length > 0) {
          getTrialGoodsPrice({productGoodsList: this.splitOrderInfoData, queryList, original: true}).then((newData) => {
            this.placeOrderTalg = false;
            this.splitOrderInfoData.map((item) => {
              newData.map((ele) => {
                if (item.ymsWarehouseId === ele.warehouseId) {
                  item.totalOrderAmount = amountHandel(ele.totalPrice); // 订单总金额
                  item.totalAmountOfGoods = amountHandel(ele.goodsPrice); // 商品总金额
                  item.processingFee = amountHandel(ele.handlePrice); // 处理费
                  item.shippingFee = amountHandel(ele.estimateFreightPrice); // 运费
                }
              });
            });
            resolve(this.splitOrderInfoData)
          });
        }
      });
    },


    // 拆分确认
    splitOrderConfirmationBtn() {
      let obj = {
        totalPrice: this.detailsObj.ymsPackageInfo.totalPrice,
        trackingNumberTime: this.detailsObj.ymsPackageInfo.trackingNumberTime,
        ymsPackageId: this.detailsObj.ymsPackageInfo.ymsPackageId,
      }
      this.$refs['collectionOfScrapFeesForLogistics'].initCollectionOfScrapFeesForLogisticsData(obj).then((value) => {
        if (!value) {
          this.saveData();
        }
      });
    },
    // 处理组装定制商品的信息
    processingCustomAssembledProducts(goodList) {
      let v = this;
      let newData = goodList.map((ele) => {
        let isNeedCustomization = ele.isNeedCustomization;
        let ymsPackageGoodsCustomizationBos = [];
        let ymsPlatformOrderTransactionId = null;
        v.ymsPlatformOrderTransactionsList.map((talg) => {
          if (ele.platformOrderTransactionId === talg.platformOrderTransactionId) {
            ymsPlatformOrderTransactionId = talg.ymsPlatformOrderTransactionId;
          }
        });
        let ymsPlatformOrderShippingDetailCs = ele.ymsPlatformOrderShippingDetailCs || [];
        if (ymsPlatformOrderShippingDetailCs.length > 0) {
          ymsPlatformOrderShippingDetailCs.map((talg) => {
            let ymsPlatformOrderShippingDetailCis = talg.ymsPlatformOrderShippingDetailCis || [];
            let data = ymsPlatformOrderShippingDetailCis.map((p, idx) => {
              return {
                md5: p.md5,
                path: p.path,
                sortNo: p.sortNo,
                type: p.type
              }
            })
            ymsPackageGoodsCustomizationBos.push({
              parts: talg.parts,
              ymsPackageGoodsCustomizationImageBos: data
            })
          })
        }
        if (isNeedCustomization === 1) {
          return {
            quantity: ele.quantity,
            ymsSku: ele.ymsSku, // 定制新生成ymsSku
            originalYmsSku: ele.originalYmsSku, // 原始ymsSku
            originalYmsProductGoodsId: ele.originalBusinessId,
            ymsProductGoodsId: ele.ymsProductGoodsId,
            isNeedCustomization: isNeedCustomization,
            ymsPlatformOrderTransactionId: ymsPlatformOrderTransactionId,
            isCustomization: ele.isCustomization,
            ymsPackageGoodsCustomizationBos: ymsPackageGoodsCustomizationBos
          }
        } else {
          return {
            quantity: ele.quantity,
            ymsSku: ele.ymsSku,
            ymsProductGoodsId: ele.ymsProductGoodsId,
            isNeedCustomization: isNeedCustomization,
            ymsPlatformOrderTransactionId: ymsPlatformOrderTransactionId,
            isCustomization: ele.isCustomization,
          }
        }
      });
      // 根据ymsProductGoodsId 去重累加 quantity
      return Object.values(newData.reduce((acc, item) => {
        if (acc[item.ymsProductGoodsId]) {
          acc[item.ymsProductGoodsId].quantity += item.quantity;
        } else {
          acc[item.ymsProductGoodsId] = {...item};
        }
        return acc;
      }, {}));
    },
    // 监听弹窗
    splitOrderChange(value) {
      if (!value) {
        this.splitOrderInfoData = [];
        this.originalNewList = [];
        this.orderProductInfoList = [];
        this.splitOrderConfirmationList = [];
        this.detailsObj = {};
        this.currentIndex = null;
      }
    }
  },
  watch: {
    splitOrderInfoData: {
      handler(data) {
        this.splitOrderInfoList = [];
        data.map((item, index) => {
          this.splitOrderInfoList.push(index + '_collapse');
        })
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    orderSubmissionModal,
    collectionOfScrapFeesForLogisticsModal,
    distributionModeModal,
    uploadIossModal
  },
};
</script>

<style lang="less" scoped>
/deep/ .commonModalStyles {
  .ivu-card-head {
    padding: 0 0 7px 0;

    .title_box {
      color: #333;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .orderLogistics_box {
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #E2E2E2;
    padding-bottom: 15px;
    margin-bottom: 18px;

    .orderLogistics_img_box {
      width: 80px;
      height: 80px;
      position: relative;

      img {
        display: inline-block;
        left: 50%;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }

    &:not(:last-child) {
      border-bottom: 1px solid #E2E2E2;
    }

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .orderLogisticsCollapse_box {
    border: none;
    background-color: transparent;

    .ivu-collapse-header {
      display: flex;
      padding: 10px 14px 10px 14px;
      background-color: #f7f7f7;
      min-height: 38px;
      line-height: initial;

      .ivu-icon-ios-arrow-forward {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    .ivu-collapse-item {
      border: 1px solid #dcdee2;
      margin-bottom: 15px;
    }

    .orderLogistics_box {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E2E2E2;
      padding-bottom: 15px;
      margin-bottom: 18px;

      .orderLogistics_img_box {
        width: 80px;
        height: 80px;
        position: relative;

        img {
          display: inline-block;
          left: 50%;
          max-height: 100%;
          max-width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(-50%);
        }
      }

      &:not(:last-child) {
        border-bottom: 1px solid #E2E2E2;
      }

      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }

  .reset_card_box {
    .ivu-card-body {
      padding: 15px 0;
    }
  }

  .reset_input_style {
    .ivu-input-number-controls-outside-btn i {
      font-size: 17px;
    }

    .ivu-input-number-input {
      text-align: center;
    }
  }

  .shippingWarehousePrompt_content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .shippingWarehousePrompt_box {
      font-size: 12px;
      position: absolute;
      left: 0px;
      bottom: -22px;
      text-align: left;
      color: #EA0000;
      width: 400px;
    }
  }
}
</style>
